Hearsay = require 'hearsay'
pluginChangedSignal = require 'views/internal/plugins/plugins-changed-signal'
pluginValidators = require 'lib/plugins/plugin-validators'
PluginBadgeView = require 'views/plugin/plugin-badge-view'
PluginModelSerializer = require 'views/internal/plugins/plugin-model-serializer'
PluginRunner = require 'views/internal/plugins/plugin-runner'
PluginView = require 'views/plugin/plugin-view'
PostRender = require 'views/lib/post-render'
Promise = require 'bluebird'
trackUe = require 'debug/trackUe'
_ = require 'underscore'

globalBadgeCache = {}
lastIdBoard = null
trackedFrontBadges = {}

module.exports = class PluginCardBadgesView extends PluginView
  tagName: 'span'
  badgeView: PluginBadgeView

  isDetailView: -> false

  runnerOptions: ->
    command: 'card-badges'
    board: @model.getBoard()
    card: @model
    timeout: 10000
    options:
      attachments: PluginModelSerializer.attachments(@model.attachmentList.models, ['id', 'name', 'url'])

  _cacheKey: ->
    { command, board, card } = @runnerOptions()
    [command, board?.id, card?.id].join(':')

  requestBadges: ->
    PluginRunner.all @runnerOptions()
    .then (pluginBadges) =>
      validBadges = _.filter(pluginBadges, pluginValidators.isValidBadge)
      currentRun = (@latestRun || 0) + 1
      @latestRun = currentRun

      resolvedBadges = []
      isCurrent = =>
        # avoid race conditions where we could render an old run over newer data
        @latestRun == currentRun
      rerender = =>
        if isCurrent()
          @renderResolvedBadges(resolvedBadges)
          # remove callbacks before caching badges; we can't trust the callbacks
          # to still be retained / available when we use the cached badges
          globalBadgeCache[@_cacheKey()] = resolvedBadges.map((b) -> _.omit(b, 'callback'))

      @cancelOnRemove Promise.map validBadges, (pluginBadge, index) =>
        @retain(pluginBadge)

        if pluginBadge.dynamic?
          update = =>
            updater = pluginBadge.dynamic()
            .cancellable()
            .then (badge) =>
              if !pluginValidators.isValidBadge(badge)
                # you may return null or undefined because you want your badge to go away
                # this will actually make sure when we re-render it will go away
                resolvedBadges[index] = undefined
                rerender()
                return

              resolvedBadges[index] = badge
              rerender()

              if badge.refresh && isCurrent()
                refresh = Math.max(10, badge.refresh)
                # Add some noise (+-1sec) to refresh interval to reduce clumping
                refresh += Math.random() * 2 - 1
                @setTimeout(update, refresh * 1000)
            .catch PluginRunner.Error.NotHandled, =>
              null

            @cancelOnRemove(updater)
            updater

          update()
        else
          resolvedBadges[index] = pluginBadge
      .cancellable()
      .then ->
        rerender()
      .catch Promise.CancellationError, (->)

  vigor: @VIGOR.NONE
  renderOnce: ->

    if (cachedBadges = globalBadgeCache[@_cacheKey()])?
      @renderResolvedBadges(cachedBadges)

    idBoard = @model.getBoard()?.id
    if idBoard && idBoard != lastIdBoard
      # when we switch boards we should clear out tracking cache
      # that way if we go back to the old board we will track it
      lastIdBoard = idBoard
      trackedFrontBadges = {}

    PostRender.enqueue "plugin_badges_render_#{ @cid }", ({ delayed }) =>
      options = @runnerOptions()

      @latestRun = 0

      debouncedRequestBadges = _.debounce =>
        @requestBadges()
      , 500

      @listenTo @model, 'change:dateLastActivity', debouncedRequestBadges
      @listenTo @model.attachmentList, 'add remove reset change', debouncedRequestBadges

      changeSignal = pluginChangedSignal(options.board, options.card)
      @subscribe changeSignal, _.after 2, (pluginData) ->
        debouncedRequestBadges()

      @waitForId @model, => @requestBadges()

    @

  trackBadges: (idPlugin) ->
    if !trackedFrontBadges[idPlugin]
      trackedFrontBadges[idPlugin] = true
      trackUe('board view', 'views', 'Power-Up', '', '', 'card-badges', idPlugin)

  renderResolvedBadges: (pluginBadges) ->
    isCardDetail = @isDetailView()
    subviews = _.filter(pluginBadges, (badge) -> pluginValidators.isRenderableBadge(badge, isCardDetail))
      .map (badge, index) =>
        # track badge views
        @trackBadges(badge.idPlugin)

        sv = @subview @badgeView, @model, { pluginBadge: badge }, index
        # We may be re-using a badge view, so make sure to use the latest badge values
        sv.updateBadge(badge)
        sv

    @ensureSubviews subviews



// WEBPACK FOOTER //
// ./app/scripts/views/plugin/plugin-badges-view.coffee